import { useCallback, useLayoutEffect, useRef } from "react";

import type { Fn } from "../fp";

function useEvent<T extends Fn>(fn: T) {
  const ref = useRef(fn);

  useLayoutEffect(() => {
    ref.current = fn;
  }, [fn]);

  const callback = useCallback(
    ((...args) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return ref.current.apply(null, args);
    }) as T,
    [],
  );

  return callback;
}

export { useEvent };
